module.exports = __webpack_public_path__ + "media/images/calendar/december-0f0fdd208b1049790989a1649fb19032.jpg";